import { ModelBase } from "@shoothill/core";

export class TodoItemModel extends ModelBase<TodoItemModel> {
    public userId: string = "";
    public title: string = "";
    public completed: boolean = false;
}
